<template>
  <div class="choice-message">
    <div class="avatar">
      <img src="@/assets/images/robot.png" class="avatar-img" alt="AI" />
    </div>
    <div class="message-body">
      <div class="sender-name">智能助手</div>
      <div class="bubble">
        <div class="content" v-if="msg.content">
          <template v-for="(seg, idx) in splitByPlate(msg.content)">
            <span
              v-if="seg.isPlate"
              :key="'p' + idx"
              style="color:#ee0a24;font-weight:bold;font-size:18px;white-space:pre-line;display:inline;"
            >{{ seg.text }}</span>
            <span
              v-else
              :key="'n' + idx"
              style="white-space:pre-line;display:inline;"
            >{{ seg.text }}</span>
          </template>
        </div>
        <div class="loading-tips" v-if="msg.loadingPlans">加载中...</div>
        <div class="options" :class="{ 'options--column': planOptions.length }">
          <!-- 计划卡片：蓝色圆圈在最前面（独立一列），其它 label 左对齐 -->
          <div
            v-for="(opt, idx) in planOptions"
            :key="idx"
            class="plan-card"
            :class="{ 'plan-card--active': selectedValue === opt.value, 'plan-card--disabled': msg.verified }"
            @click="!msg.verified && selectOption(opt)"
          >
            <span class="plan-radio" @click.stop="!msg.verified && selectOption(opt)">
              <span class="plan-radio__dot" v-if="selectedValue === opt.value"></span>
            </span>
            <div class="plan-content">
              <div class="plan-row">
                <span class="plan-label">单号:</span>
                <span class="plan-value">{{ opt.jhdh }}</span>
              </div>
              <div class="plan-row plan-row--blue">
                <span class="plan-label">送货单位:</span>
                <span class="plan-value">{{ opt.songhuodanwei }}</span>
              </div>
              <div class="plan-row plan-row--blue">
                <span class="plan-label">品名:</span>
                <span class="plan-value">{{ opt.pinzhong }}</span>
              </div>
              <div class="plan-row">
                <span class="plan-label">客户通知单号:</span>
                <span class="plan-value">{{ opt.khdh }}</span>
              </div>
              <div class="plan-row">
                <span class="plan-label">有效日期:</span>
                <span class="plan-value">{{ opt.youxiaoriqi }}</span>
              </div>
              <div class="plan-row">
                <span class="plan-label">重量:</span>
                <span class="plan-value">{{ opt.zhongliangTxt }}</span>
              </div>
            </div>
          </div>

          <!-- 兼容非计划（提货/卸货/确认等）的旧按钮 -->
          <van-button
            v-for="(opt, idx) in normalOptions"
            :key="'b' + idx"
            :type="buttonType(opt)"
            size="normal"
            :class="['choice-btn', { 'choice-btn--light-red': opt.lightRed, 'choice-btn--continue-blue': opt.continueBlue }]"
            :disabled="msg.verified"
            @click="selectOption(opt)"
          >{{ opt.text || opt }}</van-button>
        </div>
        <div class="bubble-footer" v-if="msg.time">
          <div class="time">{{ msg.time }}</div>
        </div>
      </div>
      <div class="progress" v-if="msg.progress">{{ msg.progress }}</div>
    </div>
  </div>
</template>

<script>
import plateHighlightMixin from './mixins/plateHighlight';

export default {
  name: 'ChoiceMessage',
  mixins: [plateHighlightMixin],
  props: {
    msg: { type: Object, required: true },
    index: { type: Number, default: 0 },
  },
  data() {
    return {
      selectedValue: '',
    };
  },
  computed: {
    planOptions() {
      return (this.msg.options || []).filter((o) => o && o.kind === 'plan');
    },
    normalOptions() {
      return (this.msg.options || []).filter((o) => !o || o.kind !== 'plan');
    },
  },
  watch: {
    // verified 后保留 selectedValue，让卡片继续保持蓝色边框 + 圆圈对勾，
    // 这样用户能直观看到自己选了哪一张计划。
  },
  methods: {
    buttonType(opt) {
      // 选项自带 type 时优先用（如老司机"确认车头"的继续使用→primary / 更换车头→danger）
      if (opt && typeof opt === 'object' && opt.type) return opt.type;
      const text = String(opt);
      if (text.includes('提货')) return 'primary';
      if (text.includes('卸货')) return 'success';
      if (text.includes('继续') || text.includes('确认') || text.includes('确定')) return 'info';
      return 'default';
    },
    selectOption(opt) {
      if (opt && opt.kind === 'plan') this.selectedValue = opt.value;
      // 兼容字符串和 {text,value} 对象
      const payload = typeof opt === 'object' && opt !== null ? opt : { text: opt, value: opt };
      this.$emit('choice', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.choice-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
  background: #e8f8ff;
}
.avatar-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.message-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.bubble {
  display: inline-block;
  max-width: 100%; /* 与 TextMessage 的 .bubble 对齐：填满 message-body 宽度，使气泡右侧与系统气泡右侧在同一红线 */
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  box-sizing: border-box;
}
.sender-name {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  margin-left: 0; /* 与 TextMessage 的 .sender-name 对齐 */
}
.content {
  white-space: pre-line;
}
.options {
  display: flex;
  flex-direction: row; /* 默认横向：一行显示，常见于"继续使用/更换"两个按钮等 */
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.options--column {
  flex-direction: column; /* 有 plan-card 时改回纵向堆叠 */
}
.options .choice-btn {
  flex: 1;
  min-width: 0; /* 让 flex:1 在小宽度下也能等分，避免按钮内容溢出撑大 */
}
/* ::v-deep：穿透 scoped，让 .choice-btn 命中 van-button 根元素（根元素没有本组件的 data-v 标识） */
.options ::v-deep .choice-btn {
  height: 46px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px; /* 方形圆角（van-button 默认 4px，round 时 999px） */
}
/* 浅红色变体：粉红背景 + 白字，参考截图样式 */
.options ::v-deep .choice-btn--light-red {
  background-color: #ff6b6b !important;
  border-color: #ff5252 !important;
  color: #fff !important;
}
.options ::v-deep .choice-btn--light-red:active {
  background-color: #ff5252 !important;
}
/* 蓝色变体：显式覆盖 Vant 主题色，确保"继续使用"在任何 Vant 版本/主题下都是蓝色 */
.options ::v-deep .choice-btn--continue-blue {
  background-color: #1989fa !important;
  border-color: #0570d8 !important;
  color: #fff !important;
}
.options ::v-deep .choice-btn--continue-blue:active {
  background-color: #0570d8 !important;
}
.loading-tips {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
.choice-btn {
  min-width: 80px;
}
/* ===== 计划卡片 ===== */
.plan-card {
  position: relative;
  display: flex;
  align-items: flex-start; /* 圆圈与第一行顶部对齐 */
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fafbfc;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  /* 卡片宽度跟气泡走，不要固定 min-width 把卡片挤出可视区 */
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  /* 必要时允许在任意字符处断行（避免"司"这种单字被甩到下一行） */
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.plan-card:hover {
  border-color: #c8e1ff;
  background: #f4f9ff;
}
.plan-card--active {
  border-color: #1989fa;
  background: #f4f9ff;
}
.plan-card--disabled {
  cursor: not-allowed;
}
/* 未选中的卡才发灰；选中的卡保持高亮（蓝边 + 对勾） */
.plan-card--disabled:not(.plan-card--active) {
  opacity: 0.55;
}
.plan-content {
  flex: 1;
  min-width: 0; /* 关键：允许 flex 子项内容溢出时正确处理换行 */
  display: flex;
  flex-direction: column;
}
.plan-row {
  font-size: 13px;
  line-height: 1.7;
  display: flex;
  align-items: baseline;
  word-break: keep-all;
  overflow-wrap: break-word;
  color: #333; /* 默认黑色 */
}
.plan-row .plan-label,
.plan-row .plan-value {
  color: #333; /* 默认 label + value 都黑色 */
}
.plan-row--blue,
.plan-row--blue .plan-label,
.plan-row--blue .plan-value {
  color: #1989fa; /* 送货单位 / 品名 这一行 label + value 都蓝色 */
}
.plan-row--blue {
  font-weight: 500;
}
/* 蓝色单选圆圈：单独一列在最前面 */
.plan-radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-top: 4px; /* 与第一行文字大致齐平 */
  border: 2px solid #1989fa;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  cursor: pointer;
  box-sizing: border-box;
}
.plan-radio__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1989fa;
}
/* 选中时蓝色圆圈里换成白色对勾 */
.plan-card--active .plan-radio {
  background: #1989fa;
}
.plan-card--active .plan-radio::after {
  content: '';
  width: 5px;
  height: 9px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg) translate(-1px, -1px);
}
.plan-card--active .plan-radio__dot {
  display: none;
}
.bubble-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  min-height: 18px;
}
.bubble-footer .time {
  font-size: 12px;
  color: #999;
}
.progress {
  font-size: 12px;
  color: #999;
  margin: 4px 30px 0;
}
</style>